export const formatPriceNumber = (value: number): string => {
  return value.toFixed(2);
};
